<template>
  <div class="">
    <el-table ref="multipleTable" row-key="id" :data="tableData" tooltip-effect="light" :header-cell-style="{ backgroundColor: '#ffffff', color: '#000' }">
      <el-table-column label="流水单号" align="center" width="200">
        <template slot-scope="scope">
          {{ scope.row.paymentSn || '-' }}
        </template>
      </el-table-column>
      <el-table-column label="费用单号" align="center" width="200">
        <template slot-scope="scope">
          {{ scope.row.orderSn || '-' }}
        </template>
      </el-table-column>
      <el-table-column label="收费科目" align="center" width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.itemName || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="计费时间" align="center" width="200">
        <template slot-scope="scope">
          {{ handlerDate(scope.row.chargeBeginDate, scope.row.chargeEndDate) }}
        </template>
      </el-table-column>
      <el-table-column label="计费标准" align="center" width="150">
        <template slot-scope="scope">{{ scope.row.chargeCriterionDesc || '-' }}</template>
      </el-table-column>
      <el-table-column label="应收金额" align="center" width="100">
        <template slot-scope="scope">￥{{ Number(scope.row.orderAmount || 0).toFixed(2) }}</template>
      </el-table-column>
      <el-table-column label="优惠金额" align="center" width="100">
        <template slot-scope="scope">￥{{ Number(scope.row.preferentialAmount || 0).toFixed(2) }}</template>
      </el-table-column>
      <el-table-column label="收款金额" align="center" width="100">
        <template slot-scope="scope">￥{{ Number(scope.row.payAmount || 0).toFixed(2) }}</template>
      </el-table-column>
      <el-table-column label="退款金额" align="center" width="100">
        <template slot-scope="scope">￥{{ Number(scope.row.returnAmount || 0).toFixed(2) }}</template>
      </el-table-column>
      <el-table-column label="退款状态" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.refundAuditState !== 0">{{ dictType('refundAuditStateArr', scope.row.refundAuditState) }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="收款时间" align="center" width="180">
        <template slot-scope="scope">
          {{ scope.row.payTime || '-' }}
        </template>
      </el-table-column>
      <el-table-column prop="address" label="操作" fixed="right" align="center" width="150">
        <template slot-scope="scope">
          <el-link type="primary" @click="preview(scope.row.id)">账单详情</el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="pt-30"
      layout="total, prev, pager, next, jumper,sizes"
      :current-page.sync="page.pageNo"
      :page-size.sync="page.pageSize"
      :page-sizes="[10, 50, 100]"
      :total="total"
      @size-change="currentChange"
      @current-change="currentChange"
    />
  </div>
</template>

<script>
import { paymentDetailsInfoPage, paymentDetailsInfoCount } from '@/api/finance'
export default {
  inject: ['indexThis'],
  provide() {
    return {
      indexThis: this,
    }
  },
  data() {
    return {
      tableData: [],
      page: {
        pageNo: 1,
        pageSize: 10,
      },
      total: 0,
    }
  },
  created() {
    this.orderList()
  },
  methods: {
    async orderList(params = {}) {
      const { data: res } = await paymentDetailsInfoPage({
        ...this.page,
        communityId: this.indexThis.communityId,
        ...params,
        buildingRoomIds: [this.indexThis.buildingRoomId],
      })
      this.tableData = res
      const { data: total } = await paymentDetailsInfoCount({
        ...this.page,
        communityId: this.indexThis.communityId,
        ...params,
        buildingRoomIds: [this.indexThis.buildingRoomId],
      })
      this.total = parseInt(total)
    },

    // 查看详情
    preview(id) {
      this.indexThis.$refs.CardBillDetail.orderItemList({
        communityId: this.indexThis.communityId,
        id,
      })
      this.indexThis.$refs.CardBillDetail.drawer = true
    },

    // 查看详情
    currentChange() {
      this.orderList()
    },
  },
}
</script>
